import type {
  Workspace,
  WorkspaceId,
} from '../states.d.ts';

export const workspacesState = new Map<WorkspaceId, Workspace>();
